import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

import { useAppSelector } from '@/redux/hooks';
import { getUrlFromPathname } from '@/redux/modules/config';
import { track } from '@/utils/amplitude/analytics/core';
import { TrackingEvents, TrackingPayload } from '@/utils/amplitude/analytics/core.types';
import { getAmplitudePageNameFromPath } from '@/utils/getPageNameFromPath';

type TrackSpellCorrectionRevertClickedPayload = TrackingPayload & {
    correctedQuery: string;
    originalQuery: string;
};

const trackSpellCorrectionRevertClickedAnalytics = (payload: TrackSpellCorrectionRevertClickedPayload) => {
    track(TrackingEvents.SearchPage.SpellCorrectionRevertClicked, payload);
};

export const useTrackSpellCorrectionRevertClickedAnalytics = () => {
    const { pathname, search } = useLocation();
    const url = useAppSelector((state) => getUrlFromPathname(state, pathname));

    return useCallback(
        ({ correctedQuery, originalQuery }: Omit<TrackSpellCorrectionRevertClickedPayload, 'pageName' | 'url'>) => {
            trackSpellCorrectionRevertClickedAnalytics({
                correctedQuery,
                originalQuery,
                pageName: getAmplitudePageNameFromPath(pathname, search),
                url,
            });
        },
        [pathname, search, url]
    );
};
